import type { AccountHistory } from '@api/hooks/useHistory';
import { Typography } from '@gurupay/gp-ui-library';

import SingleAccountCellItem from './SingleAccountCellItem';

export const SingleAccountRenderers = {
	date: ({ date }: AccountHistory) => <span className="whitespace-nowrap">{date}</span>,
	sender: ({ payer }: AccountHistory) => (
		<div className="flex flex-col">
			<Typography className="font-bold" level="small-text">
				{payer.iban}
			</Typography>
			<Typography className="text-neutral-600 font-medium" level="small-text">
				{payer.name}
			</Typography>
		</div>
	),
	beneficiary: ({ beneficiary }: AccountHistory) => (
		<div className="flex flex-col">
			<Typography className="font-bold" level="small-text">
				{beneficiary.iban}
			</Typography>
			<Typography className="text-neutral-600 font-medium" level="small-text">
				{beneficiary.name}
			</Typography>
		</div>
	),
	documentNo: ({ documentNumber }: AccountHistory) => (
		<Typography className="font-medium" level="small-text">
			{documentNumber}
		</Typography>
	),
	details: ({ details }: AccountHistory) => (
		<Typography className="font-medium" level="small-text">
			{details}
		</Typography>
	),
	amount: ({ amount }: AccountHistory) => (
		<Typography className="font-bold" level="small-text">
			{amount.display}
		</Typography>
	),
	statements: ({
		date,
		payer,
		beneficiary,
		documentNumber,
		details,
		amount,
	}: AccountHistory) => (
		<SingleAccountCellItem
			amount={amount}
			beneficiary={beneficiary}
			date={date}
			details={details}
			documentNumber={documentNumber}
			payer={payer}
		/>
	),
};
